import { Input } from 'antd'
import { FC, PropsWithChildren, useCallback, useRef, useState } from 'react'
import styles from '@/layouts/style.module.less'

type PropType = FC<PropsWithChildren<{
  placeholder?: string
  full?: boolean
  calssName?: string
  onSearch?: (val: string) => void
}>>

const Search: PropType = ({placeholder, full, calssName, onSearch}) => {
  const [focus, setFocus] = useState(false)
  const globalRef = useRef({
    value: ''
  })

  const handleSearch = useCallback(() => {
    if(typeof onSearch === 'function') {
      onSearch(globalRef.current.value)
    }
  }, [onSearch])

  const handleInput = useCallback((e) => {
    globalRef.current.value = e.target.value || ''
  }, [])

  return (
    <div className={`${styles['search']} ${full && styles['full-search']} ${calssName}`}>
      <div className={`${styles['search-container']} ${!full && focus && styles['search-focus']}`}>
        <Input onPressEnter={handleSearch} onInput={handleInput} className={styles['search-input']} onFocus={() => setFocus(true)} onBlur={() => setFocus(false)} placeholder={placeholder} />
        <i className='icon iconfont icon-sousuo' onClick={handleSearch}></i>
      </div>
    </div>
  )
}

export default Search
